import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { useBootstrapLabels } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-labels';
import { useBrosweLabelsByIds } from '@aibees/elephant/hooks/labels/use-broswe-labels-by-ids';
import { SearchType } from '@aibees/elephant/types';
import { Label, LabelGrouping, LabelType } from '@aibees/elephant/types/label';
import { useMemo } from 'react';

export function useTableSelectionLabels(
  selectedIds: string[],
  labelType: LabelType,
  labelIds?: string[]
): [Label[], boolean] {
  const searchType = useSearchTypeFromRoute();
  const { items: bootstrapLabels } = useBootstrapLabels(
    labelType,
    searchType === SearchType.People
      ? LabelGrouping.PEOPLE
      : LabelGrouping.COMPANY
  );

  const getLabelsByIdsApi = useBrosweLabelsByIds(
    { ids: selectedIds },
    selectedIds.length > 0
  );

  const labels = useMemo(() => {
    return bootstrapLabels.filter(
      (x) => getLabelsByIdsApi?.data?.includes(x.id) || labelIds?.includes(x.id)
    );
  }, [bootstrapLabels, getLabelsByIdsApi?.data, labelIds]);

  return useMemo(() => {
    return [labels, getLabelsByIdsApi?.isFetching ?? false];
  }, [getLabelsByIdsApi?.isFetching, labels]);
}
